import 'Cohorts/angularModule';
import 'TimeoutHelpers/angularModule';
import 'Translation/angularModule';

export default angular.module('FrontRoyal.Onboarding', [
    'FrontRoyal.Cohorts',
    'Translation',
    'timeoutHelpers',
    'gajus.swing',
]);
